<template>
    <div>
        <figure class="is-3by2">
            <l-map
                :zoom="zoom"
                :center="center"
                :bounds="mapBounds"
                ref="objectMap"
                :options="{
                    zoomControl: false,
                    minZoom: 2,
                    maxNativeZoom: 18,
                    maxZoom: 24,
                    editable: true,
                }"
                style="z-index: 19; height: 200px; border: 1px solid var(--eduloc-grey) "
            >
                    <l-control-zoom position="topright"></l-control-zoom>
                    <l-tile-layer
                        :name="$t(tileProvider.name)"
                        :visible="true"
                        :url="tileProvider.url"
                        :attribution="tileProvider.attribution"
                        :layer-type="tileProvider.type"
                        :options="tileProvider.options"
                    />
                    <l-marker
                        v-if="location"
                        :lat-lng="location | toLatLon"
                    >
                        <l-icon
                            :icon-size="dynamicSize"
                            :icon-anchor="dynamicAnchor"
                            icon-url="/img/map-icons/00_clue.svg"
                            
                        />
                    </l-marker>
            </l-map>
        </figure>
    </div>
</template>

<script>
import {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    LControl,
    LControlLayers,
    LControlZoom,
} from 'vue2-leaflet';
export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LIcon,
        LPopup,
        LControl,
        LControlLayers,
        LControlZoom,
    },
     data() {
        return {
            iconSize: 32,
            zoom: 6,
            center: [40, -2],
        }
    },
    filters: {
        toLatLon(location) {
            let latLon = [location.latitude, location.longitude];
            return latLon;
        },
    },
    props: {
        location: {
            type: Object,
            default() {
                return {};
            },
        },
        tileProvider: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    computed: {
        /*staticMapURL() {
            return staticMap(
                this.location.longitude,
                this.location.latitude,
                this.location.zoomLevel
            );
        },*/
        dynamicSize() {
            return [this.iconSize, this.iconSize * 1.15];
        },
        dynamicAnchor() {
            return [this.iconSize / 2, this.iconSize * 1.15];
        },
        mapBounds() {
            let bounds = [];
            
                if (this.location) {
                    bounds.push(
                        this.$options.filters.toLatLon(this.location)
                    );
                    let new_latitude  = this.location.latitude  + (0.10 / ((2 * Math.PI / 360) * 6378.137));
                    let new_longitude = this.location.longitude + (0.10 / ((2 * Math.PI / 360) * 6378.137)) / Math.cos( this.location.latitude * Math.PI/180);
                     
                    bounds.push(
                        this.$options.filters.toLatLon({'latitude':new_latitude,'longitude':new_longitude})
                    );
                    let new_latitude2  = this.location.latitude  - (0.10 / ((2 * Math.PI / 360) * 6378.137));
                    let new_longitude2 = this.location.longitude - (0.10 / ((2 * Math.PI / 360) * 6378.137)) / Math.cos( this.location.latitude * Math.PI/180);
                    bounds.push(
                        this.$options.filters.toLatLon({'latitude':new_latitude2,'longitude':new_longitude2})
                    );
                } else {
                    bounds.push([40, -2], [40.5, -2.5]);
                }
            return L.latLngBounds(bounds);
        },
    },
    mounted: function () {
        // console.log("in mounted treasurehunt object preview",this.tileProvider)
        delete L.Icon.Default.prototype._getIconUrl;
        L.Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        });
        this.$nextTick(() => {
            this.map = this.$refs.objectMap.mapObject;

            setTimeout(() => {
            this.map.invalidateSize();
        }, 500);
            
        });
    },
};
</script>

<style scoped>
.vue2leaflet-map /deep/ .leaflet-attribution-flag {
    display: none !important;
}
</style>
